export default __webpack_public_path__ + "713a4f04fad7d3c0bfd156d8ef9766a2.woff";